import React from 'react'
import { ButtonStyle } from './UI'
import tw from 'twin.macro'
import { useLocation } from '@reach/router';

export const JobPageHero = ({ heroImg }) => {
  const location = useLocation();
  const isActive = (url) => {
    const activeUrl = location.pathname;
    return activeUrl.includes(url) ? tw`text-black bg-[#FFFFFF]` : '';
  };

  return (
    <section tw="font-mont bg-[#F1FAFD]">
      <div tw="flex flex-row h-[830px] lg:(h-[600px])">
        {/* Image */}
        <div tw="bg-cover bg-center bg-no-repeat h-full w-full" style={{ backgroundImage: `url(${heroImg})` }}></div>
        {/* Content */}
        <div id="job-hero-headline">
          <h1 tw='text-white text-center text-[30px] mt-[25px] font-extrabold lg:(mt-[150px] text-[45px])'>See shifts based on your experience</h1>

        </div>
        <div tw='absolute top-[225px] left-[15%] w-[70%] lg:(top-[380px] left-[0] w-[100%] text-center)'>
          <div tw="text-white border-white lg:(px-[10%])">
            <div tw='block lg:(inline-block) mb-[20px]'>
              <a
                css={[
                  ButtonStyle,
                  tw`cursor-pointer inline-block py-6 px-4 w-full text-center border-[#FFFFFF] font-bold border-[1.5px] lg:(px-[0] w-[200px] text-[12px])`,
                  tw`transition-all transition-duration[0.2s] transition-timing-function[cubic-bezier(0.645,0.045,0.355,1)] hover:(text-black bg-[#FFFFFF])`,
                  isActive('registered-nurse')
                ]}
                href='/jobs/registered-nurse'
              >
                <span tw="px-4">{"Registered Nurse"}</span>
              </a>
            </div>
            <div tw='block lg:(inline-block) mb-[20px]'>
              <a
                css={[
                  ButtonStyle,
                  tw`inline-block py-6 px-4 w-full text-center border-[#FFFFFF] font-bold border-[1.5px] lg:(px-[0] w-[200px] ml-[20px] text-[12px])`,
                  tw`transition-all transition-duration[0.2s] transition-timing-function[cubic-bezier(0.645,0.045,0.355,1)] hover:(text-black bg-[#FFFFFF])`,
                  isActive('registered-practical-nurse')
                ]}
                href='/jobs/registered-practical-nurse'
              >
                <span tw="px-4">{"Registered Practical Nurse"}</span>
              </a>
            </div>
            <div tw='block lg:(inline-block) mb-[20px]'>
              <a
                css={[
                  ButtonStyle,
                  tw`inline-block py-6 px-4 w-full text-center border-[#FFFFFF] font-bold border-[1.5px] lg:(px-[0] w-[200px] ml-[20px] text-[12px])`,
                  tw`transition-all transition-duration[0.2s] transition-timing-function[cubic-bezier(0.645,0.045,0.355,1)] hover:(text-black bg-[#FFFFFF])`,
                  isActive('personal-support-worker')
                ]}
                href='/jobs/personal-support-worker'
              >
                <span tw="px-4">{"Personal Support Worker"}</span>
              </a>
            </div>
            <div tw='block lg:(inline-block) mb-[20px]'>
              <a
                css={[
                  ButtonStyle,
                  tw`inline-block py-6 px-4 w-full text-center border-[#FFFFFF] font-bold border-[1.5px] lg:(px-[0] w-[200px] ml-[20px] text-[12px])`,
                  tw`transition-all transition-duration[0.2s] transition-timing-function[cubic-bezier(0.645,0.045,0.355,1)] hover:(text-black bg-[#FFFFFF])`,
                  isActive('personal-care-aide')
                ]}
                href='/jobs/personal-care-aide'
              >
                <span tw="px-4">{"Personal Care Aide"}</span>
              </a>
            </div>
            <div tw='block lg:(inline-block) mb-[20px]'>
              <a
                css={[
                  ButtonStyle,
                  tw`inline-block py-6 px-4 w-full text-center border-[#FFFFFF] font-bold border-[1.5px] lg:(px-[0] w-[200px] ml-[20px] text-[12px])`,
                  tw`transition-all transition-duration[0.2s] transition-timing-function[cubic-bezier(0.645,0.045,0.355,1)] hover:(text-black bg-[#FFFFFF])`,
                  isActive('ct-technologist')
                ]}
                href='/jobs/ct-technologist'
              >
                <span tw="px-4">{"CT Technologist"}</span>
              </a>
            </div>
            <div tw='block lg:(inline-block) mb-[20px]'>
              <a
                css={[
                  ButtonStyle,
                  tw`inline-block py-6 px-4 w-full text-center border-[#FFFFFF] font-bold border-[1.5px] lg:(px-[0] w-[200px] ml-[20px] text-[12px])`,
                  tw`transition-all transition-duration[0.2s] transition-timing-function[cubic-bezier(0.645,0.045,0.355,1)] hover:(text-black bg-[#FFFFFF])`,
                  isActive('mri-technologist')
                ]}
                href='/jobs/mri-technologist'
              >
                <span tw="px-4">{"MRI Technologist"}</span>
              </a>
            </div>
            <div tw='block lg:(inline-block) mb-[20px]'>
              <a
                css={[
                  ButtonStyle,
                  tw`inline-block py-6 px-4 w-full text-center border-[#FFFFFF] font-bold border-[1.5px] lg:(px-[0] w-[200px] ml-[20px] text-[12px])`,
                  tw`transition-all transition-duration[0.2s] transition-timing-function[cubic-bezier(0.645,0.045,0.355,1)] hover:(text-black bg-[#FFFFFF])`,
                  isActive('occupational-therapist')
                ]}
                href='/jobs/occupational-therapist'
              >
                <span tw="px-4">{"Occupational Therapist"}</span>
              </a>
            </div>

          </div>
        </div>
      </div>
    </section>
  )
};